module.exports = __webpack_public_path__ + "media/B_L8.c4baf14c.mp3";